export default __webpack_public_path__ + "static/media/2020_CPR_and_ECC_Guidelines_graphic.5730e2d6.jpg";